import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/shared/components/ui/alert-dialog';

type RemoveSpecialtyDialogProps = {
  open: boolean;
  specialtyName: string;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
};

export function RemoveSpecialtyDialog({
  open,
  specialtyName,
  onOpenChange,
  onConfirm,
}: RemoveSpecialtyDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Remove {specialtyName}?</AlertDialogTitle>
          <AlertDialogDescription>
            This specialty&apos;s coverage will be permanently deleted when you save. This
            cannot be undone after save.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            className="bg-red-600 text-white hover:bg-red-700"
            onClick={onConfirm}
          >
            Remove specialty
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
